import React from 'react';
import {NotificationManager} from 'react-notifications';

export function toggleEvent(name, status) {
    if (status) {
        return {
            name: null,
            status: false,
        };
    }

    return {
        name,
        status: true,
    };
}

export function deleteFirstAfter20Count(arr) {
    arr.reverse();
    arr.pop();
    return arr.reverse();
}

export function getTimeFromTimestamp(timestamp) {
    if (!timestamp) {
        timestamp = new Date().getTime();
    }
    const date = new Date(timestamp);
    const hours = `0${date.getHours()}`;
    const minutes = `0${date.getMinutes()}`;
    const seconds = `0${date.getSeconds()}`;
    // Will display time in 10:30:23 format
    return `${hours.substr(-2)}:${minutes.substr(-2)}:${seconds.substr(-2)}`;
}

export function getDateAndTimeFromTimestamp(timestamp) {
    if (!timestamp) {
        timestamp = new Date().toLocaleString();
    }
    const date = new Date(timestamp * 1000).toLocaleString();
    return date;
}

export function getFormattedDate(timestamp, isEpoch) {
    if (!timestamp) {
        timestamp = new Date().getTime();
    } else {
        timestamp = isEpoch ? timestamp : timestamp * 1000;
    }

    const timestamplength = timestamp.toString().length;

    if (timestamplength === 16) {
        timestamp = Math.floor(timestamp / 1000);
    }

    const dt = new Date(timestamp);
    // const months = ['Jan',
    // 'Feb',
    // 'Mar',
    // 'Apr',
    // 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const year = dt.getFullYear();
    // const month = months[dt.getMonth()];
    const month = `0${dt.getMonth() + 1}`;
    const date = `0${dt.getDate()}`;
    const hour = `0${dt.getHours()}`;
    const min = `0${dt.getMinutes()}`;
    const sec = `0${dt.getSeconds()}`;

    return `${date.substr(-2)}/${month.substr(-2)}/${year} ${hour.substr(-2)}:${min.substr(-2)}:${sec.substr(-2)}`;
}

// export function getImageSourceFromType(notificationType) {
//     switch (notificationType) {
//         case 'Water Flooding':
//             return '../assets/images/water-droplet.png';
//         case 'Power Leakage':
//             return '../assets/images/power.png';
//         case 'Gas Leakage':
//             return '../assets/images/fire.png';
//         case 'Intrusion Detected':
//             return '../assets/images/lock.png';
//         case 'Birthday':
//             return '../assets/images/birthday.png';
//         case 'Low Battery':
//             return '../assets/images/power.png';
//         default:
//             break;
//     }
//     return ' ';
// }

export function getImageSourceFromType(notificationType) {
    switch (notificationType) {
        case 'water':
            return '../assets/images/water-droplet.png';
        case 'Power Leakage':
            return '../assets/images/power.png';
        case 'temperature':
            return '../assets/images/fire.png';
        case 'security':
            return '../assets/images/lock.png';
        case 'Birthday':
            return '../assets/images/birthday.png';
        case 'Low Battery':
            return '../assets/images/power.png';
        default:
            break;
    }
    return ' ';
}

export function getUnitFromType(notificationType) {
    switch (notificationType) {
        case 'Water Flooding':
            return <span>cm</span>;
        case 'Power Leakage':
            return <span>mA</span>;
        case 'Gas Leakage':
            return <span>g/m<sup>3</sup></span>;
        case 'Intrusion Detected':
            return <span>cm</span>;
        case 'Birthday':
            return <span>NA</span>;
        default:
            break;
    }
    return <span/>;
}

export function createNotification(message, title, type) {
    if (type === 'Success') {
        NotificationManager.success(message, title);
    } else if (type === 'Error') {
        NotificationManager.error(message, title);
    }
}

export const opennewPasswordModal = () => {
    $('#signin').toggleClass('d-none');
    $('#newPassword').toggleClass('d-none');
    $('#signin-header').text('Update Password');

    // $('#newPasswordModal').modal('show');
};

export const closenewPasswordModal = () => {
    // $('#newPasswordModal').modal('hide');
    $('#signin').toggleClass('d-none');
    $('#newPassword').toggleClass('d-none');
    $('#signin-header').text('log In');
};



// WEBPACK FOOTER //
// ./util/util.js